//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_IDENTITY_API || `${window.location.origin}/authentication`;
export interface IAdminClient {
	/**
	 * Remove User endpoint for internal use
	 * @param apiKey (optional)
	 * @param body (optional)
	 * @return Removed User
	 */
	removeUser(apiKey: string | undefined, body: RemoveUserCommand | undefined): Promise<void>;
}

export class AdminClient implements IAdminClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Remove User endpoint for internal use
	 * @param apiKey (optional)
	 * @param body (optional)
	 * @return Removed User
	 */
	removeUser(
		apiKey: string | undefined,
		body: RemoveUserCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/Admin/RemoveUser?';
		if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
		else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'DELETE',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRemoveUser(_response);
			});
	}

	protected processRemoveUser(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User does not exist', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}
}

export interface IUserClient {
	/**
	 * Register an Organisation User For Customer Portal
	 * @param body (optional)
	 * @return User Details
	 */
	registerCompanyUser(body: RegisterCompanyUserCommand | undefined): Promise<RegisterUserResponse>;
	/**
	 * Register User For Customer Portal
	 * @param body (optional)
	 * @return User Details
	 */
	registerUser(body: RegisterUserCommand | undefined): Promise<RegisterUserResponse>;
	/**
	 * Register User by email
	 * @param body (optional)
	 * @return User Details
	 */
	registerUserByEmail(body: RegisterUserByEmailCommand | undefined): Promise<RegisterUserResponse>;
	/**
	 * Authenticate User
	 * @param body (optional)
	 * @return User Authentication Token
	 */
	authenticateUser(body: AuthenticateUserCommand | undefined): Promise<AuthenticationResponse>;
	/**
	 * Change User Password
	 * @param body (optional)
	 * @return Password has changed
	 */
	setCustomerPassword(body: SetCustomerPasswordCommand | undefined): Promise<void>;
	/**
	 * Resend Verification Email
	 * @param email Users email
	 * @param realm The Realm names set up in Keycloak.
	 * @return Email sent
	 */
	resendVerificationEmail(email: string, realm: Realms): Promise<void>;
	/**
	 * Create Customer Account At TakeUp
	 * @param apiKey (optional)
	 * @param body (optional)
	 * @return User has been set up and email sent
	 */
	createCustomerFromClientReference(
		apiKey: string | undefined,
		body: CreateCustomerFromClientReferenceCommand | undefined,
	): Promise<void>;
	/**
	 * Verify Account (from customer portal after first login)
	 * @param apiKey (optional)
	 * @param body (optional)
	 * @return User has been verified
	 */
	verify(apiKey: string | undefined, body: VerifyUserCommand | undefined): Promise<void>;
	/**
	 * Check user exists
	 * @param apiKey (optional)
	 * @return User exists
	 */
	checkUserExists(apiKey: string | undefined, email: string, realm: Realms): Promise<CheckUserExistsResponse>;
	/**
	 * Remove User (for user to remove themselves)
	 * @param body (optional)
	 * @return Removed User
	 */
	removeUser(body: RemoveUserCommand | undefined): Promise<void>;
	/**
	 * Send Forgotten Password Email
	 * @param body (optional)
	 * @return Email Sent
	 */
	sendForgottenPasswordEmail(body: SendForgottenPasswordEmailCommand | undefined): Promise<void>;
	/**
	 * Determine a realm for a user based on their schema
	 * @param apiKey (optional)
	 * @param scheme (optional)
	 * @return The realm
	 */
	getRealm(apiKey: string | undefined, scheme: string | undefined): Promise<GetRealmFromScheme>;
}

export class UserClient implements IUserClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Register an Organisation User For Customer Portal
	 * @param body (optional)
	 * @return User Details
	 */
	registerCompanyUser(
		body: RegisterCompanyUserCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<RegisterUserResponse> {
		let url_ = this.baseUrl + '/api/v1/User/RegisterCompanyUser';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRegisterCompanyUser(_response);
			});
	}

	protected processRegisterCompanyUser(response: AxiosResponse): Promise<RegisterUserResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User Details not found', status, _responseText, _headers, result404);
		} else if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RegisterUserResponse>(result200);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('User Already has an account', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RegisterUserResponse>(null as any);
	}

	/**
	 * Register User For Customer Portal
	 * @param body (optional)
	 * @return User Details
	 */
	registerUser(body: RegisterUserCommand | undefined, cancelToken?: CancelToken): Promise<RegisterUserResponse> {
		let url_ = this.baseUrl + '/api/v1/User/RegisterUser';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRegisterUser(_response);
			});
	}

	protected processRegisterUser(response: AxiosResponse): Promise<RegisterUserResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User Details not found', status, _responseText, _headers, result404);
		} else if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RegisterUserResponse>(result200);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('User Already has an account', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RegisterUserResponse>(null as any);
	}

	/**
	 * Register User by email
	 * @param body (optional)
	 * @return User Details
	 */
	registerUserByEmail(
		body: RegisterUserByEmailCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<RegisterUserResponse> {
		let url_ = this.baseUrl + '/api/v1/User/RegisterUserByEmail';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRegisterUserByEmail(_response);
			});
	}

	protected processRegisterUserByEmail(response: AxiosResponse): Promise<RegisterUserResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User Details not found', status, _responseText, _headers, result404);
		} else if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RegisterUserResponse>(result200);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('User Already has an account', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RegisterUserResponse>(null as any);
	}

	/**
	 * Authenticate User
	 * @param body (optional)
	 * @return User Authentication Token
	 */
	authenticateUser(
		body: AuthenticateUserCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<AuthenticationResponse> {
		let url_ = this.baseUrl + '/api/v1/User/AuthenticateUser';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processAuthenticateUser(_response);
			});
	}

	protected processAuthenticateUser(response: AxiosResponse): Promise<AuthenticationResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<AuthenticationResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			return throwException('User Details not found', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<AuthenticationResponse>(null as any);
	}

	/**
	 * Change User Password
	 * @param body (optional)
	 * @return Password has changed
	 */
	setCustomerPassword(body: SetCustomerPasswordCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/User/SetCustomerPassword';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSetCustomerPassword(_response);
			});
	}

	protected processSetCustomerPassword(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 204) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 403) {
			const _responseText = response.data;
			let result403: any = null;
			let resultData403 = _responseText;
			result403 = resultData403;
			return throwException('Forbidden', status, _responseText, _headers, result403);
		} else if (status === 404) {
			const _responseText = response.data;
			return throwException('User Details not found', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Resend Verification Email
	 * @param email Users email
	 * @param realm The Realm names set up in Keycloak.
	 * @return Email sent
	 */
	resendVerificationEmail(email: string, realm: Realms, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/User/ResendVerificationEmail?';
		if (email === undefined || email === null)
			throw new Error("The parameter 'email' must be defined and cannot be null.");
		else url_ += 'Email=' + encodeURIComponent('' + email) + '&';
		if (realm === undefined || realm === null)
			throw new Error("The parameter 'realm' must be defined and cannot be null.");
		else url_ += 'Realm=' + encodeURIComponent('' + realm) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'POST',
			url: url_,
			headers: {},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processResendVerificationEmail(_response);
			});
	}

	protected processResendVerificationEmail(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unable to connect to Keycloak', status, _responseText, _headers, result401);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Create Customer Account At TakeUp
	 * @param apiKey (optional)
	 * @param body (optional)
	 * @return User has been set up and email sent
	 */
	createCustomerFromClientReference(
		apiKey: string | undefined,
		body: CreateCustomerFromClientReferenceCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/User/CreateCustomerFromClientReference?';
		if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
		else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCreateCustomerFromClientReference(_response);
			});
	}

	protected processCreateCustomerFromClientReference(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('User Already has an account', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Verify Account (from customer portal after first login)
	 * @param apiKey (optional)
	 * @param body (optional)
	 * @return User has been verified
	 */
	verify(apiKey: string | undefined, body: VerifyUserCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/User/Verify?';
		if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
		else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processVerify(_response);
			});
	}

	protected processVerify(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else {
			const _responseText = response.data;
			let resultdefault: any = null;
			let resultDatadefault = _responseText;
			resultdefault = resultDatadefault;
			return throwException('Error', status, _responseText, _headers, resultdefault);
		}
	}

	/**
	 * Check user exists
	 * @param apiKey (optional)
	 * @return User exists
	 */
	checkUserExists(
		apiKey: string | undefined,
		email: string,
		realm: Realms,
		cancelToken?: CancelToken,
	): Promise<CheckUserExistsResponse> {
		let url_ = this.baseUrl + '/api/v1/User/CheckUserExists?';
		if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
		else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
		if (email === undefined || email === null)
			throw new Error("The parameter 'email' must be defined and cannot be null.");
		else url_ += 'Email=' + encodeURIComponent('' + email) + '&';
		if (realm === undefined || realm === null)
			throw new Error("The parameter 'realm' must be defined and cannot be null.");
		else url_ += 'Realm=' + encodeURIComponent('' + realm) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCheckUserExists(_response);
			});
	}

	protected processCheckUserExists(response: AxiosResponse): Promise<CheckUserExistsResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CheckUserExistsResponse>(result200);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User does not exist', status, _responseText, _headers, result404);
		} else {
			const _responseText = response.data;
			let resultdefault: any = null;
			let resultDatadefault = _responseText;
			resultdefault = resultDatadefault;
			return throwException('Error', status, _responseText, _headers, resultdefault);
		}
	}

	/**
	 * Remove User (for user to remove themselves)
	 * @param body (optional)
	 * @return Removed User
	 */
	removeUser(body: RemoveUserCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/User/RemoveUser';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'DELETE',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRemoveUser(_response);
			});
	}

	protected processRemoveUser(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User does not exist', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Send Forgotten Password Email
	 * @param body (optional)
	 * @return Email Sent
	 */
	sendForgottenPasswordEmail(
		body: SendForgottenPasswordEmailCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/User/SendForgottenPasswordEmail';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSendForgottenPasswordEmail(_response);
			});
	}

	protected processSendForgottenPasswordEmail(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('User does not exist', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Determine a realm for a user based on their schema
	 * @param apiKey (optional)
	 * @param scheme (optional)
	 * @return The realm
	 */
	getRealm(
		apiKey: string | undefined,
		scheme: string | undefined,
		cancelToken?: CancelToken,
	): Promise<GetRealmFromScheme> {
		let url_ = this.baseUrl + '/api/v1/User/GetRealm?';
		if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
		else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
		if (scheme === null) throw new Error("The parameter 'scheme' cannot be null.");
		else if (scheme !== undefined) url_ += 'scheme=' + encodeURIComponent('' + scheme) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetRealm(_response);
			});
	}

	protected processGetRealm(response: AxiosResponse): Promise<GetRealmFromScheme> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetRealmFromScheme>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Realm was not found', status, _responseText, _headers, result404);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetRealmFromScheme>(null as any);
	}
}

export interface AuthenticationResponse {
	access_token?: string | undefined;
	expires_in?: number;
	refreshToken?: any | undefined;
}

export interface AuthenticateUserCommand {
	email: string;
	password: string;
	realm: Realms;
}

export interface CreateCustomerFromClientReferenceCommand {
	/** Customer First Name */
	firstName: string;
	/** Customer Last Name */
	lastName: string;
	/** Customer Email address */
	email: string;
	/** ICE Client Reference */
	clientReference: string;
	realm: Realms;
}

export interface RegisterCompanyUserCommand {
	/** Users organisation/company name */
	companyName: string;
	/** Users first name */
	firstName: string;
	/** Users last name */
	lastName: string;
	/** Users date of birth */
	dateOfBirth: string;
	/** Users email */
	email: string;
	/** Users password */
	password: string;
	/** Users policy number */
	policyNumber: string;
	/** Users post code */
	postCode: string;
	/** Users vehicle registration */
	vehicleRegistrationNumber: string;
	realm: Realms;
}

export interface RegisterUserByEmailCommand {
	/** Users Email */
	email: string;
	realm: Realms;
}

export interface RegisterUserCommand {
	/** Users first name */
	firstName: string;
	/** Users last name */
	lastName: string;
	/** Users date of birth */
	dateOfBirth: string;
	/** Users email */
	email: string;
	/** Users password */
	password: string;
	/** Users policy number */
	policyNumber: string;
	/** Users post code */
	postCode: string;
	/** Users vehicle registration */
	vehicleRegistrationNumber: string;
	realm: Realms;
}

export interface RegisterUserResponse {
	customerReference?: string | undefined;
}

export interface RemoveUserCommand {
	/** Users Email */
	email: string;
	realm: Realms;
}

export interface SendForgottenPasswordEmailCommand {
	/** Users Email */
	email: string;
	realm: Realms;
}

export interface SetCustomerPasswordCommand {
	/** The customers email */
	email: string;
	/** The new password the user wants to set. */
	newPassword: string;
	realm: Realms;
}

export interface VerifyUserCommand {
	userId: string;
	realm: Realms;
}

export interface CheckUserExistsResponse {
	userId?: string | undefined;
	userVerified?: boolean;
	userEmailVerified?: boolean;
	realm?: string | undefined;
}

export interface GetRealmFromScheme {
	realm?: string | undefined;
}

export enum Realms {
	ACORN = 'ACORN',
	CARROT = 'CARROT',
	MOTORCADE = 'MOTORCADE',
	BRIEFLY = 'BRIEFLY',
	FLAG = 'FLAG',
	MYPOLICY = 'MYPOLICY',
	STREET_COVER = 'STREET_COVER',
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
